import { formatPhoneNumberForApi } from '../utils/formatNumber';

export class DialogSaveAdapter {
    constructor(data) {
        this.newData = { ...data };

        const transformations = {
            phone: () => {
                const { phone, ...restData } = this.newData;
                this.newData = restData;
                this.newData.phone = phone
                    ? formatPhoneNumberForApi(phone)
                    : '';
            },
            phoneNumber: () => {
                const { phone, ...restData } = this.newData;
                this.newData = restData;
                this.newData.phone = phone
                    ? formatPhoneNumberForApi(phone)
                    : '';
            },
            role: () => {
                const { role, ...restData } = this.newData;
                this.newData = restData;
                this.newData.roleId = role?.id || null;
            }
        };

        for (const prop in this.newData) {
            if (transformations[prop]) {
                transformations[prop]();
            }
        }
    }
}
